import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sportType'
})
export class SportTypePipe implements PipeTransform {

  transform(ids: string[] | null | undefined, prefix = 'SPORT_TYPES'): OptionItem[] {
    if (!ids?.length) return [];
    return ids.map(id => ({
      id,
      labelKey: `${prefix}.${id}` // e.g. SPORT_TYPES.football
    }));
  }

}

export interface OptionItem {
  id: string;
  labelKey: string;
}
